import React, { Component } from 'react'
import { Fade } from 'react-slideshow-image'
import InfiniteScroll from 'react-infinite-scroller'
import ImageGallery from 'react-image-gallery'
import Divider from '@material-ui/core/Divider'
import Img3 from 'components/img4'
import Img from 'components/img'
import { NavLink } from 'react-router-dom'
import VideoPlayer from 'react-video-markers'
import '../imageCarousel.css'
// import FrontStream from 'containers/FrontPgStream'
import Designer from '../PublicDisplay/Designer'
import Buyer from '../PublicDisplay/Buyer'
import Grid from '../PublicDisplay/Grid'
import Banner from '../PublicDisplay/Banner'
import ReactPlayer from 'react-player/lazy'
import Carousel from '../../ImageCarousel/promopg'
import Iframe from 'react-iframe'


import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import 'react-tabs/style/react-tabs.css'

const styles = {
    imageSlide: {
        display: 'block',
        margin: 'auto',
        width: '100%',
        height: '100%',
        marginBottom: '5.5%',
        maxWidth: '1000px',
        maxHeight: '700px'

    },
    divProp: {
        marginTop: '2%',
        display: 'inline-block',
        textAlign: 'center'
    },
    main: {
        backgroundColor: 'transparent',
        width: '100%',
        height: '600px',
        borderStyle: 'solid',
        borderWidth: '.0px',
        borderColor: '#33383b',
        textAlign: 'center',
        margin: 'auto'

    },
    img3: {
        width: '100%',
        height: `${window.outerHeight * .9}px`,
        marginTop: '.01%',
        textAlign: 'center',
        justifyContent: 'center',
        borderStyle: 'solid',
        borderWidth: '0px',
        borderColor: '#33383b'
    }
}
const fadeImages = [
    '../possibleBackgrounds/canvas.jpg',
    '../possibleBackgrounds/DSC_0864.jpg',
    '../possibleBackgrounds/madonna.jpg'
]

const fadeProperties = {
    // duration: 8000,
    transitionDuration: 900,
    infinite: true,
    indicators: true,
    size: 'contain',
    arrows: false,
    scale: .4,
    autoplay: false,
    width: '100%',
}

export const MobileFront = () => {
    return (
        <div style={window.outerWidth > 500 ? { marginTop: '0px' } : { marginTop: '0px' }}>
            <div style={{ position: 'relative', marginTop: '0px' }}>
               
<div 
style={
  window.outerWidth > 500 ?
  {backgroundImage: `url(https://firebasestorage.googleapis.com/v0/b/dc1-ba765.appspot.com/o/ezgif.com-video-to-gif.png?alt=media&token=f65f2150-5a61-4968-a753-8fb2774920ca)`}
  :
  {backgroundImage: `url(https://firebasestorage.googleapis.com/v0/b/dc1-ba765.appspot.com/o/ezgif.com-video-to-gif.png?alt=media&token=f65f2150-5a61-4968-a753-8fb2774920ca)`,
  backgroundAttachment: 'initial',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundPositionX: '67%',
  height: '600px'
  }

}
  className={window.outerWidth > 500 ? "bgimg-1" : 'bgimg-3'}>
  <div className="caption"
    style={{opacity: '1'}}>
  <NavLink to={'/collection/Sweaters'}>
  <span className="border1">Designs from around the Globe</span>
  </NavLink>
  </div>
</div>

            </div>


            {/* <div >
  <div className="caption"
    style={{opacity: '1'}}>
  <NavLink to={'/collection/Sweaters'}>
  <span className="border1">Make A Splasher</span>
  </NavLink>
  </div>
</div> */}

            <div className='tabformat' style={{ textAlign: 'center', marginTop: '12%' }}>
                {/* 
    <div className='FrontBanner'>
<Banner/>
    </div> */}

                <Carousel arrows={false}>
                    <div style={{ margin: 'auto', textAlign: 'center', width: '100%' }}>
                        <p style={{ fontSize: '1.6em', margin: '0' }}>
                            Independent Designers
  </p>
                        <p style={{ fontSize: '1.2em', width: '65%', margin: 'auto', padding: '3%' }}>
                            Buy Directly from designers that put their heart into every stitch.
  </p>
                    </div>
                    <div>

                        <p style={{ fontSize: '1.6em', margin: 0 }}>
                            Discover Styles
    </p>

                        <p style={{ fontSize: '1.2em', width: '65%', margin: 'auto', padding: '3%' }}>
                            With the Hullthread Region feature, just click on the map and you will be shown the best selling clothing in that region.</p>
                    </div>

                    <div>
                        <p style={{ fontSize: '1.6em', margin: 0 }}>
                            Augmented Reality
    </p>

                        <p style={{ fontSize: '1.2em', width: '85%', margin: 'auto', padding: '3%' }}>
                            Use Augmented reality to put clothing right in the room with you.
  </p>
                    </div>
                </Carousel>

                <h3 className="category_title" style={{ textAlign: 'left', marginTop: '15%' }}>Designer Spotlight</h3>
                <Carousel>
                    <div style={{ marginTop: '55px' }}>
                    <a href ='https://www.zeffmanuel.com/' >
  <h3 className='DesignerInfo' style={{textAlign: 'center', textDecoration: 'underline'}}>Zeff Manuel</h3>
</a>
                        <div className='threeimg'>
                            {/* <img src='https://scontent-lga3-2.cdninstagram.com/v/t51.2885-15/sh0.08/e35/p640x640/116332160_117919986445486_3195684145786470938_n.jpg?_nc_ht=scontent-lga3-2.cdninstagram.com&_nc_cat=110&_nc_ohc=bc2AU5dIopcAX-2MUNm&oh=cb4287c56ea5a4e6b009843330e56f93&oe=5F482CAC' /> */}
                            <img src='https://scontent-lga3-2.cdninstagram.com/v/t51.2885-15/sh0.08/e35/p640x640/97966213_1153110508358016_8710225006199310292_n.jpg?_nc_ht=scontent-lga3-2.cdninstagram.com&_nc_cat=100&_nc_ohc=fj8vov3EOwsAX_1oGmL&oh=60c8e1cc59f1a151e62564fd373ed7cf&oe=5F464FF8' />
                            {/* <img src='https://scontent-lga3-2.cdninstagram.com/v/t51.2885-15/sh0.08/e35/p640x640/95434520_321041845558391_3955606960584698066_n.jpg?_nc_ht=scontent-lga3-2.cdninstagram.com&_nc_cat=111&_nc_ohc=ZvJo7ZpLrtIAX9H80E3&oh=6718e8d33df0efbd5db19f3fb30e5d99&oe=5F490E59' /> */}
                        </div>
                    </div>

                    <div style={{ marginTop: '85px' }}>
                        <h3 className='DesignerInfo' style={{ textAlign: 'center', textDecoration: 'underline' }}>Playboyz</h3>

                        <div className='threeimg'>
                            <img src='https://scontent-lga3-2.cdninstagram.com/v/t51.2885-15/sh0.08/e35/p640x640/116531104_957397411377217_639708848318628503_n.jpg?_nc_ht=scontent-lga3-2.cdninstagram.com&_nc_cat=101&_nc_ohc=H9m4G8KU-foAX8ZRDWM&oh=fbd0be61effe776ae477e8c4fabed47f&oe=5F4AA98A' />
                            {/* <img style={{ maxHeight: '83.3%' }} src='https://firebasestorage.googleapis.com/v0/b/dc1-ba765.appspot.com/o/IMG_2845.jpg?alt=media&token=92535962-bd33-4b3b-85e2-0cd016dd3a96' /> */}
                            {/* <img src='https://firebasestorage.googleapis.com/v0/b/dc1-ba765.appspot.com/o/IMG_2859.jpg?alt=media&token=f9825ea2-87c8-45f4-9708-a49f47a8e9c6' /> */}

                        </div>
                    </div>
                </Carousel>
                {/* <div style={{ color: '#777', backgroundColor: 'white', textalign: 'center', padding: '50px 0px', textAlign: 'justify', marginTop: '6%' }}>
                    <h3 className="category_title" style={{ textAlign: 'left' }}>New Arrivals</h3>
                    <FrontStream Filter={'Sweaters'} index={'posts'} main={'hello'} />
                </div> */}

                <div style={{ padding: '20px', fontFamily: 'Roboto' }}>
                    <div style={{ padding: '30px', marginTop: '13%' }} className='ThirdColumn'>
                        Getting started
  </div>
                    <br />

                    <div>
                        <Tabs className='FrontTabs'>
                            <TabList>
                                <Tab style={{ fontFamily: 'Askan-Light', fontSize: '20px' }}>Designer</Tab>
                                <Tab style={{ fontFamily: 'Askan-Light', fontSize: '20px' }}>Buyer</Tab>
                            </TabList>

                            <TabPanel>
                                <Designer />
                            </TabPanel>

                            <TabPanel>
                                <Buyer />
                            </TabPanel>
                        </Tabs>
                    </div>

                    {/* <div style={{textAlign: 'center', justifyContent: 'center'}}>
<Grid/>
</div> */}

                </div>

                <div style={{ marginTop: '13%' }} className='ThirdColumn'>
                    Manufacturing Partners
  </div>

                <div className='threeimg'>
                    <img style={{ width: 'auto', margin: 'auto' }} src='https://firebasestorage.googleapis.com/v0/b/dc1-ba765.appspot.com/o/manufacturer%20logos%2Fapparel%20prouction.png?alt=media&token=189e9fdd-7d70-45d5-a003-28129fd3a7a2' />
                    <img src='https://firebasestorage.googleapis.com/v0/b/dc1-ba765.appspot.com/o/manufacturer%20logos%2Fbcco.jpg?alt=media&token=112c7cec-2c50-4c41-8a8e-e0ffbc65ea7f' />
                    <img style={{ width: 'auto', margin: 'auto' }} src='https://firebasestorage.googleapis.com/v0/b/dc1-ba765.appspot.com/o/manufacturer%20logos%2Fnyfl.jpg?alt=media&token=d5ea6573-0ebf-433f-8886-83bd3d66bd2e' />
                    <img style={{ width: 'auto', margin: 'auto' }} src='https://firebasestorage.googleapis.com/v0/b/dc1-ba765.appspot.com/o/manufacturer%20logos%2Furth.png?alt=media&token=263b5e39-a63b-4e4f-b32d-f5baa11bfaca' />
                    <img src='https://firebasestorage.googleapis.com/v0/b/dc1-ba765.appspot.com/o/manufacturer%20logos%2Fstudio%20one.png?alt=media&token=b663ba33-2c06-47fa-b7c9-aa31bb9a2837' />

                </div>

                <div style={{ marginTop: '15%' }} className='ThirdColumn'>
                    WE'VE GOT YOU COVERED
  </div>

                <div className='facts'>
                    <div>
                        <p style={{ fontSize: '20px', margin: '0' }}>
                            2 Day shipping
  </p>
                        <p style={{ fontSize: '15px', width: '65%', margin: 'auto' }}>
                            Get what you want, fast ! 2 day shipping is included in all HullThread purchases.
  </p>
                    </div>
                    <div>

                        <p style={{ fontSize: '20px', margin: 0 }}>
                            Secure payments
    </p>

                        <p style={{ fontSize: '15px', width: '65%', margin: 'auto' }}>
                            We have partnered with Stripe to make sure all your sensitive information stays protected.  </p>
                    </div>

                    <div>
                        <p style={{ fontSize: '20px', margin: 0 }}>
                            Easy Returns
    </p>

                        <p style={{ fontSize: '15px', width: '65%', margin: 'auto' }}>
                            Didn't Love what you recieved? No problem, we make returns quick and easy.
  </p>
                    </div>
                </div>

                {/* <div className='ThirdColumn'>
    Our Story
  </div>
  <div className=''>
    Ever have that friend that is always asking you where you got that Sweater? Or where you bought those jeans. 
    Well that was our CEO for most of college. And during the hunt to find these designers we realized that
    there are so many talented designers out there and the best clothing doesnt just come from Big brand names.
    And that these designers werent getting the recognition they deserved. So we made a platform where you'll never have to
    ask "Where'd you get that from again" and where designers can have a home that allows them to share their art with the world.
  </div> */}
            </div>
        </div>
    )
}

export default MobileFront


// WEBPACK FOOTER //
// ./src/containers/FrontPg/ImageCarousel/FrontPages/DesignerTab.jsx